import React, { useState } from 'react';
import { NewCalender } from '../../componentsUpdated/Dashboard/Db/Explore/NewCalender';

const ServicesCard = ({ cartItems, data, handleClick, cardId, calender }) => {
  const {
    svc_name,
    svc_cat_desc,
    svc_typ_desc,
    svc_desc,
    svc_cost_amt,
    svc_provider_local_cost_amt,
    svc_photo1,
  } = data;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleCartData = (item, bookingData) => {
    if (!item || !item.svc_id || !bookingData) {
      return;
    }

    const newItem = {
      svc_id: item.svc_id,
      svc_name: item.svc_name,
      svc_qnty_nbr: 1,
      svc_status_id: 1,
      svc_price_amt: item.svc_cost_amt || 0,
      svc_provider_cost_amt: item.svc_provider_cost_amt || 0,
      svcfee_id: 1,
      sys_ordl_active_yn: 'Y',
      ord_svc_date: bookingData?.ord_svc_date,
      ord_svc_time: bookingData?.ord_svc_time,
      svcf_id: item.svc_svcf_id,
      sys_user_id: '160',
      sys_crte_tsp: '2024-07-24 13:15:24',
      sys_last_updte_tsp: '2024-12-02 02:20:09',
      order_ship_instructions: '',
    };

    const existingCartData = cartItems ?? [];

    handleClick([...existingCartData, newItem]);
  };

  return (
    <div className=" shadow-lg mt-2 md:mt-10 px-4 py-9 rounded-lg">
      <NewCalender
        selectedID={cardId}
        show={isModalOpen}
        onHide={handleModal}
        calendar={calender}
        handleCartData={(dateData) => handleCartData(data, dateData)}
      />
      <div className="flex items-center space-x-4">
        <div className="flex justify-center items-center">
          {svc_photo1 ? (
            <img
              src={svc_photo1}
              className="w-12 h-12 rounded-full"
              alt="hospital"
            />
          ) : (
            <img
              src={'/health/images/hospital.svg'}
              className="h-12 w-12"
              alt="hospital"
            />
          )}
        </div>
        <div className="flex flex-col">
          <span className="text-lg font-semibold  text-start">{svc_name}</span>
          <span className="text-sm font-medium text-start">{svc_desc}</span>
        </div>
      </div>
      <div className="flex flex-col gap-y-9 py-5">
        <div className="flex justify-between">
          <div className="w-1/2 text-start">
            <div className="text-midGray text-sm">Service Category :</div>
            <div className=" mb-0">{svc_cat_desc}</div>
          </div>
          <div className="w-1/2 text-end text-wrap">
            <div className="text-midGray text-sm">Service Type:</div>
            <div className=" mb-0">{svc_typ_desc}</div>
          </div>
        </div>
        <div className="flex justify-between">
          <div className="w-1/2 text-start">
            <div className="text-midGray text-sm">Zimbabwe Dollar (ZiG):</div>
            <div className=" mb-0">$ {svc_provider_local_cost_amt}</div>
          </div>
          <div className="w-1/2 text-end text-wrap">
            <div className="text-midGray text-sm">Service Code (USD) :</div>
            <div className=" mb-0">$ {svc_cost_amt}</div>
          </div>
        </div>
      </div>
      <button
        className="bg-primary-blue text-white capitalize py-1.5 rounded-md w-full"
        onClick={handleModal}
      >
        <div className="flex justify-center items-center space-x-2">
          <div>
            <img src={'/health/images/cart.svg'} alt="cart" />
          </div>
          <div>Add to cart</div>
        </div>
      </button>
    </div>
  );
};

export default ServicesCard;
